import {Component, Prop, Vue} from 'vue-facing-decorator';
import { ref } from "vue";

@Component({
    name: 'app-footer',
})
export default class Footer extends Vue{
    @Prop() app_base_data = ref([]);
}